import * as React from 'react';

import { createIcon } from '../Icon';
export const ArrowDownLeftIcon = createIcon(
  <React.Fragment>
    <line x1={17} y1={7} x2={7} y2={17} />
    <polyline points="17 17 7 17 7 7" />
  </React.Fragment>,
  'ArrowDownLeftIcon'
);
